export function drawBlendMode(renderContext, node, render) {
  const { context } = renderContext;

  // 仅当 blendMode 存在且不是 'normal' 时才处理
  if (node.blendMode && node.blendMode !== 'normal') {
    // 保存当前状态
    context.save();

    // 设置混合模式
    context.globalCompositeOperation = node.blendMode;

    // 渲染内容
    render();

    // 恢复状态
    context.restore();
  } else {
    render();
  }
}

// 支持的混合模式列表
export const SUPPORTED_BLEND_MODES = [
  'normal',
  'multiply', // 正片叠底
  'screen', // 滤色
  'overlay', // 叠加
  'darken', // 变暗
  'lighten', // 变亮
  'color-dodge', // 颜色减淡
  'color-burn', // 颜色加深
  'hard-light', // 强光
  'soft-light', // 柔光
  'difference', // 差值
  'exclusion', // 排除
  'hue', // 色相
  'saturation', // 饱和度
  'color', // 颜色
  'luminosity', // 明度
];
